
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import DropdownOption from "@/entities/DropdownOption";
  import FormGroup from "@/components/form/FormGroupNew.vue";


  @Component({
    components: {
      DropdownFilter,
      FormGroup
    },

  })

  export default class MultiSelectComponent extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({required: true, type: Array}) options!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
    @Prop({ type: String, default: "Select an Option" }) readonly placeholder?: string;
    @Prop({ type: Boolean, default: false }) readonly isLoading?: boolean;
    @Prop({ type: Boolean, default: false }) readonly searchable?: boolean;
    @Prop({ type: Boolean, default: false }) readonly multiple?: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled?: boolean;
    @Prop({ type: Boolean, default: true }) readonly withoutLoading?: boolean;
    @Prop({ type: Number, default: 500 }) readonly debounceTime?: number;
    @Prop({ type: String, default: '' }) readonly classess?: number;

    // options: DropdownOption[] = this.options;
    searchText = "";

    @Watch('searchText')
    onChangeSearch(oldvalue,newValue){
    this.$emit("onSearch", newValue);
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
      this.options = [];
    }
  }
